import axios from 'axios'
import store from '@/store'

export default {
  notify(text){
                var slackData = {
                  "channel"  : "#ag-login",
                  "username" : "Ag Login",
                  "icon_url" : "https://app.irricrops.com/img/favicons/apple-touch-icon.png",
                  "attachments": [
                    {
                      //"title"    : d.data.user.id+" - "+d.data.user.name,
                      "title" : text,
                      //"color": d.data.user.email.split("@irricrops.com").length > 1 ? "#388e3c":"#3AA3E3",
                      "color":"#388e3c",
                      "attachment_type": "default",

                      "fields": [
                          {
                            "title": "usuario",
                            "value": store.getters.userName || "NO DATA",
                            "short": true
                          },
                          {
                            "title": "email",
                            "value": store.getters.userEmail|| "NO DATA",
                            "short": true
                          },
                          {
                            "title": "REF",
                            "value": window.location.href,
                            "short": true
                          },
                        ]
                    }]
                };

                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                  slackData.username = "AG Login Mobile";
                  //slackData.image_url =  "https://app.irricrops.com/img/favicons/apple-touch-icon.png",
                  delete slackData.image_url;
                  slackData.icon_emoji = ":iphone:";
                  slackData.attachments[0].fields.push({
                    "title" : "mobile phone",
                    "value" : navigator.userAgent,
                    "short" : false
                  });
                }

                //https://api.slack.com/messaging/webhooks


                if(window.location.hostname.split("agrogesttion.irricrops.com").length > 1){


                /**
                curl -X POST -H
                'Content-type: application/json'
                --data '{"text":"Hello, World!"}'
                https://hooks.slack.com/services/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
                */


                console.log("slack notify");
                  delete axios.defaults.headers.common["Authorization"];
                  delete axios.defaults.headers.post["Content-type"];
                  axios({
                    url    : 'https://hooks.slack.com/services/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',
                    method : "POST",
                    // dataType: 'json',
                    // processData: false,
                    headers: {
                      //'Content-type': 'application/json',
                    },
                    data   : JSON.stringify(slackData),
                    //data   : '{"text":"Hello, World! from '+window.location.hostname+'"}',
                  }).then(res =>{
                    console.dir(res);
                  }, resError =>{
                    console.error(resError);
                  });

                }
}
}
